class AccordionPaneComponent {
  constructor() {
    Object.assign(this, {
      accordionCtrl: null,
      open: false,
    });
  }

  $onInit() {
    this.accordionCtrl.addPane(this);
  }
}

angular.module('pims')
  .component('accordionPane', {
    transclude: {
      header: 'accordionHeader',
    },
    templateUrl: 'app/components/accordion/pane/accordion-pane.component.html',
    controller: AccordionPaneComponent,
    controllerAs: 'vm',
    bindings: {
      open: '<?',
    },
    require: {
      accordionCtrl: '^accordion',
    },
  });
